import React from 'react';
import { Box, Typography } from '@mui/material';
import colorConfigs from '../../../configs/colorConfigs';
import { typo } from '../../../assets/fonts/font';
import ContactForm from '../../common/ContactForm/ContactForm';

const DeleteAccountPage: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        background: colorConfigs.secondary,
        paddingY: 3,
        minHeight: 'calc(100vh - 120px)',
      }}
    >
      <Box
        sx={{
          maxWidth: '800px',
          width: '75%',
          mx: 'auto',
          textAlign: 'center',
          mb: 2,
        }}
      >
        <Typography variant="h4" sx={{ ...typo.sectionHeadline, mb: 1 }}>
          Request Account Deletion
        </Typography>
        <Typography sx={typo.bodyContent}>
          Submit this form to request deletion of your account and associated personal data.
          Please provide the same name, mobile number, and email address linked to your account.
        </Typography>
      </Box>
      <ContactForm initialRemarks="Account Deletion Request" />
    </Box>
  );
};

export default DeleteAccountPage;
